import * as React from 'react';

/**
 * A loading animiation, basically ripped wholesale from Volaris's own site.
 */
export function Loader() {
  return (
    <div className="loading-background">
      <span className="loader-container">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/loader.tsx